import { Injectable, inject } from '@angular/core';
import { PlanoHistoricosDataService } from './feature-plano-historicos.dataservice.service';
import {
  IVincularPlano,
  ICancelarPlano,
  IRelatorioHistoricoFiltro,
} from '@nomoh-monorepo/shared-types';

@Injectable({ providedIn: 'root' })
export class PlanoHistoricosService {
  private planoHistoricosDataService = inject(PlanoHistoricosDataService);

  // PRINCÍPIO KISS: Component injeta DataService diretamente para signals
  // Service apenas para business logic com validações

  async gerarRelatorio(): Promise<void> {
    // Business logic: Validar permissão
    // await this.permissionService.validarPermissao('plano-historico.read');

    return this.planoHistoricosDataService.gerarRelatorio();
  }

  async buscarHistoricos(
    filtros?: Partial<IRelatorioHistoricoFiltro>
  ): Promise<void> {
    // await this.permissionService.validarPermissao('plano-historico.read');

    return this.planoHistoricosDataService.gerarRelatorio({ filtros });
  }

  async vincularPlano(dados: IVincularPlano): Promise<string> {
    // Business logic: Validar permissão crítica
    // await this.permissionService.validarPermissao('plano-historico.vincular');

    // Validações de negócio
    if (!dados.pessoaId || dados.pessoaId.trim().length === 0) {
      throw new Error('ID da pessoa é inválido');
    }

    if (!dados.planoId || dados.planoId.trim().length === 0) {
      throw new Error('ID do plano é inválido');
    }

    return this.planoHistoricosDataService.vincularPlano(dados);
  }

  async cancelarPlano(dados: ICancelarPlano): Promise<void> {
    // await this.permissionService.validarPermissao('plano-historico.cancelar');

    // Validações de negócio
    if (!dados.historicoId || dados.historicoId.trim().length === 0) {
      throw new Error('ID do histórico é inválido');
    }

    if (!dados.motivo || dados.motivo.trim().length === 0) {
      throw new Error('Motivo do cancelamento é obrigatório');
    }

    if (dados.motivo.length < 10) {
      throw new Error(
        'Motivo do cancelamento deve ter pelo menos 10 caracteres'
      );
    }

    return this.planoHistoricosDataService.cancelarPlano(dados);
  }

  async buscarPorPessoa(pessoaId: string): Promise<void> {
    // await this.permissionService.validarPermissao('plano-historico.read');

    if (!pessoaId || pessoaId.trim().length === 0) {
      throw new Error('ID da pessoa é inválido');
    }

    return this.planoHistoricosDataService.buscarPorPessoa(pessoaId);
  }

  // Métodos de navegação (sem validação adicional necessária)
  async proximaPagina(): Promise<void> {
    return this.planoHistoricosDataService.proximaPagina();
  }

  async paginaAnterior(): Promise<void> {
    return this.planoHistoricosDataService.paginaAnterior();
  }

  async irParaPagina(pagina: number): Promise<void> {
    return this.planoHistoricosDataService.irParaPagina(pagina);
  }

  async alterarTamanhoPagina(limit: number): Promise<void> {
    return this.planoHistoricosDataService.alterarTamanhoPagina(limit);
  }

  resetState(): void {
    return this.planoHistoricosDataService.resetState();
  }
}
